import { useSelector } from "react-redux";
import { bool, func } from "prop-types";
import Tooltip from "@shared/v2/Tooltip";

import { isPlace } from "./helpers";

import IconButton from "../../../shared/v2/IconButton";
import { Grid2RegularV6 } from "../../../shared/v2/Icomoon";

const ResourceBtn = ({ open = false, setOpen = () => {} }) => {
  const theme = useSelector(({ layout }) => layout.theme.name);

  return (
    <Tooltip
      innerClassName="!tw-bg-neutral-gray-75"
      arrowClassName="tw-fill-neutral-gray-75"
      trigger={
        <IconButton
          aria-label="App Launcher"
          className={`${isPlace(theme) ? "tw-text-white" : ""}  hover:tw-bg-gray/20 active:tw-bg-gray/30`}
          id="resourceIcon"
          aria-haspopup="true"
          aria-expanded={open}
          onClick={setOpen}
          schema="transparent"
        >
          <Grid2RegularV6 size="xxl" />
        </IconButton>
      }
      content="App Launcher"
      placement="bottom"
    />
  );
};

export default ResourceBtn;

ResourceBtn.propTypes = {
  open: bool,
  setOpen: func,
};
